import { webapiApi } from '../../webapiApi';

// =============================================================================
// Types (matching OpenAPI spec — TenantResponse / TenantModules)
// =============================================================================

/** Single source of truth for tenant module literals (enum-like `as const`). */
export const TenantModule = {
  Sea: 'Sea',
  Warehouse: 'Warehouse',
  RoadTransport: 'RoadTransport',
  Billing: 'Billing',
  Containers: 'Containers',
  DraftOutboundOrders: 'DraftOutboundOrders',
  DraftRoadTransportOrders: 'DraftRoadTransportOrders',
} as const;
export type TenantModule = (typeof TenantModule)[keyof typeof TenantModule];

export type TenantIntegrationStatus = 'Pending' | 'Active';

export interface TenantResponse {
  id: string;
  name: string;
  code: string;
  erpIntegrationStatus: TenantIntegrationStatus;
  idpIntegrationStatus: TenantIntegrationStatus;
  modules: TenantModule[];
}

// =============================================================================
// API Endpoints
// =============================================================================

export const clientTenantsApi = webapiApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientTenant: builder.query<TenantResponse, void>({
      query: () => '/tenants',
      providesTags: [{ type: 'Tenant', id: 'CURRENT' }],
    }),
  }),
});

export const { useGetClientTenantQuery } = clientTenantsApi;
